import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../constants";
import "./admin.css";
import axios from 'axios';

export default function AddUserForm({ rafraichir, token }) {
  const [inscriptionUser, setInscriptionUser] = useState({ nom: "", prenom: "", mail: "", password: "", type: "" });
  const navigate = useNavigate();
  const [messageMailUser, setMessageMailUser] = useState("");
  const [messageMailInvalide, setMessageMailInvalide] = useState("");
  const [erreurEmailExistant, setErreurEmailExistant] = useState(false);
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);

  const clearMessages = () => {
    setTimeout(() => {
      setMessageMailUser("");
      setMessageMailInvalide("");
      setErreurEmailExistant(false);
    }, 5000);
  };

  useEffect(() => { clearMessages(); }, [messageMailUser, messageMailInvalide, erreurEmailExistant]);

  const handleChange = (event) => {
    const { name, type, checked, value } = event.target;
    if (type === "checkbox") {
      if (name === "twoFactorEnabled") setTwoFactorEnabled(checked);
    } else {
      setInscriptionUser({ ...inscriptionUser, [name]: value });
    }
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const showMessagePopup = (message) => alert(message);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!validateEmail(inscriptionUser.mail)) {
      setMessageMailInvalide("Adresse e-mail invalide");
      return;
    }

    if (isNaN(inscriptionUser.type) || inscriptionUser.type < 0 || inscriptionUser.type > 4) {
      setMessageMailInvalide("Le champ Type doit être un nombre entre 0 et 4");
      return;
    }

    axios.post(
      `${API_URL}/users/register`,
      {
        nom: inscriptionUser.nom,
        prenom: inscriptionUser.prenom,
        mail: inscriptionUser.mail,
        password: inscriptionUser.password,
        type: parseInt(inscriptionUser.type),
        twoFactorEnabled,
        twoFactorPending: twoFactorEnabled,
      },
      { headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: "Bearer " + token } }
    )
      .then((response) => {
        if (response.status === 401) {
          showMessagePopup("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
          localStorage.clear();
          navigate.push("/login");
        } else if (response.status === 409) {
          setErreurEmailExistant(true);
          setMessageMailInvalide("L'adresse e-mail est déjà utilisée !");
        } else {
          return response.data;
        }
      })
      .then(
        (result) => {
          if (result?.message) setMessageMailUser(result.message);
          rafraichir();
          window.location.reload();
          setInscriptionUser({ nom: "", prenom: "", mail: "", password: "", type: "" });
        },
        (error) => {
          if (error.response?.data?.statusCode === 401) {
            showMessagePopup("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
            localStorage.clear();
            navigate.push("/login");
          } else if (error.response?.data?.statusCode === 409) {
            setErreurEmailExistant(true);
          }
        }
      );
  };

  const inputClass = "w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm bg-gray-50 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition";

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-3">
      <p className="text-xs uppercase tracking-widest text-gray-400 font-semibold mb-1">Nouvel utilisateur</p>

      <div className="grid grid-cols-2 gap-3">
        <input className={inputClass} type="text" name="nom" placeholder="Nom" onChange={handleChange} value={inscriptionUser.nom} />
        <input className={inputClass} type="text" name="prenom" placeholder="Prénom" onChange={handleChange} value={inscriptionUser.prenom} />
      </div>

      <input className={inputClass} type="email" name="mail" placeholder="Adresse e-mail" onChange={handleChange} value={inscriptionUser.mail} />
      <input className={inputClass} type="password" name="password" placeholder="Mot de passe" onChange={handleChange} value={inscriptionUser.password} />

      <select
        className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition"
        name="type"
        onChange={handleChange}
        value={inscriptionUser.type}
      >
        <option value="">Niveau d'accès</option>
        <option value="0">SuperAdmin</option>
        <option value="1">Admin</option>
        <option value="2">Chef d'agence</option>
        <option value="3">Chef d'atelier</option>
        <option value="4">Capteur</option>
      </select>

      {/* Toggle 2FA */}
      <label className="flex items-center gap-3 cursor-pointer select-none py-1">
        <div
          onClick={() => setTwoFactorEnabled(!twoFactorEnabled)}
          className={`relative w-10 h-6 rounded-full transition-colors duration-200 cursor-pointer shrink-0
            ${twoFactorEnabled ? 'bg-loginBordure' : 'bg-gray-200'}`}
        >
          <span className={`absolute top-1 w-4 h-4 rounded-full bg-white shadow transition-transform duration-200
            ${twoFactorEnabled ? 'translate-x-5' : 'translate-x-1'}`}
          />
        </div>
        <span className="text-sm text-gray-600">Activer la double authentification</span>
      </label>

      <input
        type="submit"
        value="Ajouter l'utilisateur"
        className="w-full bg-loginBordure hover:bg-blue-900 text-white text-sm font-semibold py-2.5 rounded-xl transition-all duration-200 cursor-pointer border-none mt-1"
      />

      {erreurEmailExistant && (
        <div className="flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 rounded-xl px-3 py-2 text-sm font-medium">
          <span className="w-2 h-2 rounded-full bg-red-500 shrink-0" />
          L'adresse e-mail est déjà utilisée !
        </div>
      )}
      {messageMailInvalide && !erreurEmailExistant && (
        <div className="flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 rounded-xl px-3 py-2 text-sm font-medium">
          <span className="w-2 h-2 rounded-full bg-red-500 shrink-0" />
          {messageMailInvalide}
        </div>
      )}
      {messageMailUser && (
        <div className="flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 rounded-xl px-3 py-2 text-sm font-medium">
          <span className="w-2 h-2 rounded-full bg-emerald-500 shrink-0" />
          {messageMailUser}
        </div>
      )}
    </form>
  );
}